// extracted by mini-css-extract-plugin
module.exports = {"dateWrapper":"ArticleButton_dateWrapper__a9SQM","active":"ArticleButton_active__rqsgR","line":"ArticleButton_line__2WObN","foo":"ArticleButton_foo__JuLkA"};